import Api from '../http.service';

//Fetch all SetrviceType
export const fetchServiceTypeList = () => Api.GET({ url: 'service_type' });
